import {
  InfoIcon,
  InfoOutlineIcon,
  LinkIcon,
  PlusSquareIcon,
  TimeIcon,
} from "@chakra-ui/icons";
import myglamm from "../Images/myglamm front page.png";
import mailchimp from "../Images/mail.png";
import Indeed from "../Images/indeed front.png";
import youtube from "../Images/Youtube front.png";
import Shopping from "../Images/Shopping.jpeg";

import { Box, Flex, Grid, Image, Text } from "@chakra-ui/react";
import React from "react";
import { Link } from "react-router-dom";
import ProjectComponent from "./Project";

function Projects({ colorMode }) {
  return (
    <Box id="projects" mt="10" position="relative">
      <br />
      <br />
      <Box position={"absolute"} w="100%">
        <Image
          src="https://d1edzrgaei4psf.cloudfront.net/newHome/12.svg"
          opacity=".3"
          w="100%"
        />
      </Box>
      <Flex w="full" justifyContent={"center"} position="relative">
        <Text
          color="orange.500"
          fontSize="22px"
          letterSpacing="20px"
          fontWeight="700"
          mt="5"
        >
          PROJECTS
        </Text>
      </Flex>
      <br />
      <Grid
        w="90%"
        m="auto"
        gridTemplateColumns={{
          base: "repeat(1fr)",
          md: "repeat(2,1fr)",
          lg: "repeat(3,1fr)",
        }}
        gap="9"
        rowGap={"9"}
      >
        {arr?.map((el, i) => {
          return <ProjectComponent colorMode={colorMode} key={i} {...el} />;
        })}
      </Grid>
    </Box>
  );
}

export default Projects;

const arr = [
  {
    image: Shopping,
    title: "Shopping",
    techStack:
      "HTML , CSS , Javascript , React ,Redux, Chakra Ui , Node Js , Express , MongoDB ,Jwt-authentication, Jwt-token, Razorpay  ",
    desc: "Shopping Clone is MERN Stack e-commerce web application that allows you to buy Mobile , Electronics and Grocery products online. It has a variety of categories.",
    link: "https://shoppingbykc.vercel.app/",
    watch: "",
    github: "https://github.com/KanhaiyaChauhan037/E-commerce",
    solo: "A individual Project executed in 15 days",
  },
  {
    image: mailchimp,
    title: "Clone of MailChimp",
    techStack:
      "HTML , CSS , Javascript , React, Redux , Chakra Ui , Node Js , Express , MongoDB , Mail,Jwt-authentication, Jwt-token ",
    desc: "Grow your business on your terms with Mailchimp's All-In-One marketing, automation & email marketing platform. Easy to use - start for free!.",
    link: "https://emailomatic.netlify.app/ ",
    watch: "",
    github: "https://github.com/VinayKumar1801/rebel-hook-6465",
    solo: "A Group Project of 5 members, executed in 05 days",
  },
  {
    image: myglamm,
    title: "Clone of Myglamm",
    techStack:
      "HTML , CSS , Javascript , React , Redux , Chakra Ui , Node Js , Express , MongoDB , Firebase ",
    desc: "Myglamm Clone is MERN Stack e-commerce web application that allows you to buy cosmetics and personal care products online. It has a variety of categories.",
    link: "https://whitefeather.netlify.app/",
    watch: "",
    github: "https://github.com/KanhaiyaChauhan037/succinct-wrench-1095",
    solo: "A Group Project of 5 members, executed in 05 days",
  },
  {
    image: youtube,
    title: "Clone of Youtube",
    techStack: "HTML , CSS , Javascript",
    desc: "YouTube is an American free online video sharing and social media platform, is the second most visited website that makes it easy to watch online videos. You can even create and upload your own videos.",
    link: "https://superlative-naiad-db20cb.netlify.app/",
    watch: "",
    github: "https://github.com/KanhaiyaChauhan037/Youtube-Clone",
    solo: "A solo Project executed in 02 days",
  },
  {
    image: Indeed,
    title: "Clone of Indeed",
    techStack: "HTML , CSS , Javascript",
    desc: "Indeed is an American worldwide employment website for job listings.You may also include soft skills, like communication and problem-solving, as well as personality traits that you expect from a successful candidate.",
    link: "https://chic-starship-330803.netlify.app/",
    watch: "",
    github: "https://github.com/KanhaiyaChauhan037/Bitter-level-627",
    solo: "A Group Project of 5 members, executed in 04 days",
  },
];
